import script from "./InvoiceSettingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoiceSettingsView.vue?vue&type=script&setup=true&lang=ts"

import "./InvoiceSettingsView.vue?vue&type=style&index=0&id=48327e52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48327e52"]])

export default __exports__